import OptimizerEditDto from "./OptimizerEditDto";

export class DirectOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.iters = null;
        /** @type {number} */
        this.eps = null;
        /** @type {number} */
        this.fMinRtol = null;
        /** @type {Boolean} */
        this.locallyBiased = null;
        /** @type {number} */
        this.volTol = null;
    }

    /**
     * @typedef {Object} _DirectOptimizerEditDtoProps
     * @property {number} iters
     * @property {number} eps
     * @property {number} fMinRtol
     * @property {Boolean} locallyBiased
     * @property {number} volTol
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _DirectOptimizerEditDtoProps} DirectOptimizerEditDtoProps
     */
    /**
     * 
     * @param {DirectOptimizerEditDtoProps} props
     * @returns {DirectOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.iters = props.iters;
        this.eps = props.eps;
        this.fMinRtol = props.fMinRtol;
        this.locallyBiased = props.locallyBiased;
        this.volTol = props.volTol;
        return this;
    }
}

export default DirectOptimizerEditDto;